import type { ReactNode } from 'react'
import { EditorList } from '@/features/legends/components/EditorList'
import type { MutatorType } from '@/features/legends/effects/effects'
import type { MutatorTypeInfo } from '@/features/legends/effects/mutator-registry'

export interface EffectEditorProps {
  /**
   * The mutators, as sortable rows.
   */
  children?: ReactNode
  mutatorTypes: readonly MutatorTypeInfo[]
  onAdd: (type: MutatorType) => unknown
  isDisabled?: boolean
  testId?: string
}

/**
 * The mutators an effect runs, in order, with a menu to add more.
 */
export function EffectEditor({
  children,
  mutatorTypes,
  onAdd,
  isDisabled,
  testId,
}: EffectEditorProps) {
  return (
    <EditorList<MutatorType>
      isSpaced
      isDisabled={isDisabled}
      addLabel="Add mutator"
      addOptions={mutatorTypes.map((t) => ({
        id: t.type,
        title: t.title,
        description: t.description,
      }))}
      onAddOption={onAdd}
      testId={testId}
    >
      {children}
    </EditorList>
  )
}
